// extracted by mini-css-extract-plugin
module.exports = {"remove-icon":"_2Hq8DnlCNnrktayeZC-rQ3","list-box":"_1W6WjrVRcTRYKpZt3LVIrx"};